<template>
  <div
    class="m-edition-section-content-info-submenu m-edition-section-content-info-submenu-products"
  >
    <ul>
      <li>
        <router-link
          :class="[$t('mEditionMenu.product.satellitesIncluded.children.juedroop.subedition') === $route.params.subedition
                ? 'submenu-item-active submenu-item-active-products'
                : '']"
          :to="`/${$t('rPaths.product')}/${$route.params.id}/${$t('mEditionMenu.product.satellitesIncluded.subject')}/${$t('mEditionMenu.product.satellitesIncluded.children.juedroop.subedition')}`"
        >
          {{ $t('mEditionMenu.product.satellitesIncluded.children.juedroop.subtext') }}
        </router-link>
      </li>
      <!-- Evaluaciones se oculta hasta que el Droop esté terminado (configApp.droopEvaluacionHabilitado) -->
      <li v-if="evaluacionHabilitada">
        <router-link
          :class="[$t('mEditionMenu.product.satellitesIncluded.children.evaluacion.subedition') === $route.params.subedition
                ? 'submenu-item-active submenu-item-active-products'
                : '']"
          :to="`/${$t('rPaths.product')}/${$route.params.id}/${$t('mEditionMenu.product.satellitesIncluded.subject')}/${$t('mEditionMenu.product.satellitesIncluded.children.evaluacion.subedition')}`"
        >
          {{ $t('mEditionMenu.product.satellitesIncluded.children.evaluacion.subtext') }}
        </router-link>
      </li>
      <!-- Ruleta, igual: se oculta hasta que el Droop esté terminado (configApp.droopRuletaHabilitado) -->
      <li v-if="ruletaHabilitada">
        <router-link
          :class="[$t('mEditionMenu.product.satellitesIncluded.children.ruleta.subedition') === $route.params.subedition
                ? 'submenu-item-active submenu-item-active-products'
                : '']"
          :to="`/${$t('rPaths.product')}/${$route.params.id}/${$t('mEditionMenu.product.satellitesIncluded.subject')}/${$t('mEditionMenu.product.satellitesIncluded.children.ruleta.subedition')}`"
        >
          {{ $t('mEditionMenu.product.satellitesIncluded.children.ruleta.subtext') }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import configApp from '@/config'

export default {
  name: 'MoleculeEditionProductSatellitesIncludedSubMenu',

  computed: {
    evaluacionHabilitada () {
      return configApp.droopEvaluacionHabilitado === true
    },

    ruletaHabilitada () {
      return configApp.droopRuletaHabilitado === true
    }
  }
}
</script>
